import { useEffect } from "react";
import { captureUTM } from "@/lib/utm";
import { loadClarity } from "@/lib/clarity";

/**
 * Mounts once at app root.
 * - Captures UTM/gclid/yclid from URL on first load and persists 30 days.
 * - Lazy-loads Microsoft Clarity if VITE_CLARITY_PROJECT_ID is configured.
 */
export function UtmAndAnalyticsBootstrap() {
  useEffect(() => {
    captureUTM();
    // Defer Clarity to idle to keep LCP intact
    const ric = (window as any).requestIdleCallback as
      | ((cb: () => void) => number)
      | undefined;
    if (ric) ric(() => loadClarity());
    else setTimeout(loadClarity, 2500);
  }, []);
  return null;
}
